import { Eyebrow, Reveal } from './Reveal';

export default function Leadership() {
  return (
    <section id="leadership" data-testid="ceo-section" className="scroll-mt-28 bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">
          {/* Portrait */}
          <div className="lg:col-span-5">
            <Reveal>
              <div className="relative mx-auto max-w-md">
                <div aria-hidden="true" className="absolute -left-4 -top-4 h-full w-full rounded-[2rem] border-2 border-lime" />
                <div className="relative overflow-hidden rounded-[2rem] shadow-lift ring-1 ring-slate-200/80">
                  <img
                    src="/assets/ceo.jpg"
                    alt="Chief Executive Officer of Sania Job Bowl Pvt. Ltd."
                    data-testid="ceo-portrait"
                    className="aspect-[4/4.6] w-full object-cover object-top transition-transform duration-700 ease-out hover:scale-[1.02]"
                    loading="lazy"
                  />
                </div>
              </div>
            </Reveal>
          </div>

          {/* Copy */}
          <div className="lg:col-span-7">
            <Reveal>
              <Eyebrow index="04">Leadership</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-5 font-display text-3xl font-extrabold tracking-tight text-ink sm:text-4xl lg:text-[2.75rem] lg:leading-[1.12]">
                Meet our <span className="text-royal">Chief Executive Officer</span>
              </h2>
              <p className="mt-4 font-display text-2xl font-extrabold text-ink sm:text-3xl" data-testid="ceo-name">
                Puvvala Nagaraju
              </p>
              <p className="mt-1.5 font-mono text-[11px] font-semibold uppercase tracking-[0.26em] text-slate-400">
                Chief Executive Officer · Sania Job Bowl Pvt. Ltd. · Bengaluru, India
              </p>
              <div className="mt-4 flex flex-wrap gap-2" data-testid="ceo-roles">
                {['CEO', 'Entrepreneur', 'Team Leader'].map((r) => (
                  <span
                    key={r}
                    className="rounded-full bg-lime-soft px-3.5 py-1.5 font-display text-xs font-bold text-lime-deep"
                  >
                    {r}
                  </span>
                ))}
              </div>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-600 sm:text-lg" data-testid="ceo-bio">
                A visionary entrepreneur and results-driven CEO passionate about building businesses, empowering
                people, and developing high-performing teams. Focused on strategic leadership, innovation, talent
                development, and operational excellence. Committed to creating a culture of accountability,
                collaboration, and continuous growth while leading Sania Job Bowl toward long-term success.
              </p>
              <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-600">
                Leadership at Sania Job Bowl is guided by the brand&apos;s founding promise —
                <span className="font-display font-bold italic text-royal"> A smile in Every Job</span> — connecting
                talent, empowering businesses and creating opportunities through integrated workforce and career
                solutions.
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <div className="mt-8 grid max-w-xl grid-cols-1 gap-4 sm:grid-cols-2">
                <div className="rounded-2xl border border-slate-200/80 bg-porcelain p-5 transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-card">
                  <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.22em] text-lime-deep">Our mission</p>
                  <p className="mt-2 text-sm font-semibold leading-relaxed text-ink">
                    Make hiring simpler, more accessible and more dependable.
                  </p>
                </div>
                <div className="rounded-2xl border border-slate-200/80 bg-porcelain p-5 transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-card">
                  <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.22em] text-pine">Our vision</p>
                  <p className="mt-2 text-sm font-semibold leading-relaxed text-ink">
                    Build a trusted employment ecosystem.
                  </p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
